import { BDAY_SESSION_ID, supabase } from "./supabase";

const BUCKET = "bday-journals";

export async function uploadJournalImage(day: string, file: File): Promise<string> {
  if (!supabase) throw new Error("Supabase is not configured");

  const safeDay = day.replace(/[^a-zA-Z0-9-_ ]/g, "").trim() || "journal";
  const ext = file.name.split(".").pop()?.toLowerCase() || "jpg";
  const path = `${BDAY_SESSION_ID}/${safeDay}/${Date.now()}-${Math.random().toString(36).slice(2)}.${ext}`;

  const { error } = await supabase.storage.from(BUCKET).upload(path, file, {
    cacheControl: "3600",
    upsert: false,
  });

  if (error) throw error;

  const { data } = supabase.storage.from(BUCKET).getPublicUrl(path);
  return data.publicUrl;
}

export async function removeJournalImage(imageUrl: string): Promise<void> {
  if (!supabase) return;

  const marker = `/object/public/${BUCKET}/`;
  const index = imageUrl.indexOf(marker);
  if (index === -1) return;

  const path = decodeURIComponent(imageUrl.slice(index + marker.length));
  await supabase.storage.from(BUCKET).remove([path]);
}
